import React from "react";
import {
  Box,
  Button,
  MenuItem,
  Select,
  Typography,
  CircularProgress,
  Modal,
  IconButton,
} from "@mui/material";
import "../css/RoomModal.css";
import { BiX } from "react-icons/bi";
import "../css/RoomModal.css";
import { useTranslation } from "react-i18next";

function AddContactModal({
  newContact,
  handleNewContactChange,
  handleAddContactSave,
  handleCloseModal,
  loading,
  error,
  open,
  handleClose,
}) {
  const { t } = useTranslation();

  return (
    <Modal open={open} onClose={handleClose}>
      <Box className="modalStyle">
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mb={4}
        >
          <Typography variant="h5" fontWeight="bold" color="secondary">
            {t("studentDetails.addContact.addNewContact")}
          </Typography>
          <IconButton onClick={handleClose} size="small">
            <BiX />
          </IconButton>
        </Box>

        <Box mb={3}>
          <Typography
            variant="body1"
            component="label"
            display="block"
            color="secondary"
            gutterBottom
          >
            {t("studentDetails.addContact.firstName")}
          </Typography>
          <input
            type="text"
            value={newContact.FirstName}
            className={"form-control"}
            onChange={(e) =>
              handleNewContactChange("FirstName", e.target.value)
            }
            placeholder={t("studentDetails.addContact.enterFirstName")}
          />
        </Box>

        <Box mb={3}>
          <Typography
            variant="body1"
            component="label"
            display="block"
            color="secondary"
            gutterBottom
          >
            {t("studentDetails.addContact.lastName")}
          </Typography>
          <input
            type="text"
            value={newContact.LastName}
            className={"form-control"}
            onChange={(e) => handleNewContactChange("LastName", e.target.value)}
            placeholder={t("studentDetails.addContact.enterLastName")}
          />
        </Box>
        <Box mb={3}>
          <Typography
            variant="body1"
            component="label"
            display="block"
            color="secondary"
            gutterBottom
          >
            {t("studentDetails.addContact.email")}
          </Typography>
          <input
            type="email"
            value={newContact.email}
            className={"form-control"}
            onChange={(e) => handleNewContactChange("Email", e.target.value)}
            placeholder={t("studentDetails.addContact.enterEmail")}
          />
        </Box>

        <Box mb={3}>
          <Typography
            variant="body1"
            component="label"
            display="block"
            color="secondary"
            gutterBottom
          >
            {t("studentDetails.addContact.phone")}
          </Typography>
          <input
            type="phone"
            value={newContact.phone}
            className={"form-control"}
            onChange={(e) => handleNewContactChange("Phone", e.target.value)}
            placeholder={t("studentDetails.addContact.enterPhone")}
          />
        </Box>

        <Box mb={3}>
          <Typography variant="body1" color="secondary" gutterBottom>
            {t("studentDetails.addContact.canPickUp")}
          </Typography>
          <Select
            fullWidth
            displayEmpty
            value={newContact.CanPickUp ? "true" : "false"}
            onChange={(e) =>
              handleNewContactChange("CanPickUp", e.target.value === "true")
            }
            sx={{
              height: "40px",
              "& .MuiSelect-select": {
                paddingTop: "8px",
                paddingBottom: "8px",
              },
            }}
          >
            <MenuItem value="" disabled>
              --- {t("actions.select")} ---
            </MenuItem>
            <MenuItem value="true">Yes</MenuItem>
            <MenuItem value="false">No</MenuItem>
          </Select>
        </Box>

        <Box mb={3}>
          <Typography variant="body1" color="secondary" gutterBottom>
            {t("studentDetails.addContact.signedUp")}
          </Typography>
          <Select
            fullWidth
            displayEmpty
            value={newContact.SignedUp ? "true" : "false"}
            onChange={(e) =>
              handleNewContactChange("SignedUp", e.target.value === "true")
            }
            sx={{
              height: "40px",
              "& .MuiSelect-select": {
                paddingTop: "8px",
                paddingBottom: "8px",
              },
            }}
          >
            <MenuItem value="" disabled>
              --- {t("actions.select")} ---
            </MenuItem>
            <MenuItem value="true">Yes</MenuItem>
            <MenuItem value="false">No</MenuItem>
          </Select>
        </Box>
        <Box mb={3}>
          <Typography
            variant="body1"
            component="label"
            display="block"
            color="secondary"
            gutterBottom
          >
            {t("studentDetails.addContact.contactType")}
          </Typography>
          <input
            type="text"
            value={newContact.contactType}
            className={"form-control"}
            onChange={(e) =>
              handleNewContactChange("ContactType", e.target.value)
            }
            placeholder={t("studentDetails.addContact.enterContactType")}
          />
        </Box>

        <Box mb={3}>
          <Typography
            variant="body1"
            component="label"
            display="block"
            color="secondary"
            gutterBottom
          >
            {t("studentDetails.addContact.contactStatus")}
          </Typography>
          <input
            type="text"
            value={newContact.contactStatus}
            className={"form-control"}
            onChange={(e) =>
              handleNewContactChange("ContactStatus", e.target.value)
            }
            placeholder={t("studentDetails.addContact.enterContactStatus")}
          />
        </Box>

        <Box display="flex" justifyContent="flex-end">
          <Button
            variant="contained"
            color="secondary"
            onClick={handleClose}
            disabled={loading}
            sx={{
              backgroundColor: "transparent",
              boxShadow: "none",
              color: (theme) => theme.palette.secondary.main,
              border: "none",
              "&:hover": {
                backgroundColor: "rgba(240, 236, 236, 0.04)", // subtle hover effect or customize
                boxShadow: "none",
              },
            }}
          >
            {t("actions.cancel")}
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={handleAddContactSave}
            disabled={loading}
            startIcon={loading && <CircularProgress size={20} />}
            className="submitButton"
          >
            {loading ? t("actions.saving") : t("actions.save")}
          </Button>
        </Box>

        {error && (
          <Typography color="error" sx={{ mt: 2 }}>
            {error}
          </Typography>
        )}
      </Box>
    </Modal>
  );
}

export default AddContactModal;
